import axios from 'axios'

var qs = require('qs');
var root = window.API_ROOT



export const getListData = (params) => {
  return axios.post(root + '/set/dept/listPage', qs.stringify(params))
}

export const getDeptList = (params) => {
  return axios.post(root + '/set/dept/list', qs.stringify(params))
}

//删除行
export const deleteData = (params) => {
  return axios.post(root + '/set/dept/remove', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.post(root + '/set/dept/detail', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params, flag) => {
  if (!flag) {//修改
    return axios.post(root + '/set/dept/update', qs.stringify(params))
  } else {
    return axios.post(root + '/set/dept/save', qs.stringify(params))
  }
}

export const independentDept = () => {
  return axios.post(root + '/set/dept/independentDept', null, {noloading: true})
}


export const listlaoxianAllStore = () => {
  if (root.indexOf('yougoujingcang.com') > -1) {
    return axios.post('//b2capi.yougoujingcang.com/set/dept/listAllStore', qs.stringify({noxy: 1}))
  }
  return axios.post(root.replace('2b', '') + '/set/dept/listAllStore', qs.stringify({noxy: 1}))
}



// WEBPACK FOOTER //
// ./src/api/set/dept.js